module.exports = __webpack_public_path__ + "img/41_8.fa17ac6b.png";